<template>
  <div class="page-container">
    <div class="left-part">
      <div class="main-title">
        <div class="main-title-text-eng">X-Brick Tool</div>
        <div class="main-title-text-chs">一键排砖工具</div>
      </div>
      <div class="bottom-text">
        X-Brick Tool on ARP | XKool.ai<br />
        Designed and Developed by ART | XKool © All rights reserved
      </div>
    </div>

    <div class="right-part">
      <div class="sub-title">
        <div class="sub-title-text-eng">Start your Brick Journey</div>
        <div class="sub-title-text-chs">开启搬砖旅程</div>
      </div>
      <div class="drop-card">
        <img :src="titleLogo" alt="title img" width="50%" />
        <div class="drop-title-text">'What do you want, brick?'</div>
        <div class="drop-content-text">
          Louis Kahn said to a brick.<br />And brick said to you, 'I like an
          arch.'<br /><br />What do you want the brick to be?<br />10 different
          brick walls<br />can now be generated with one click!
        </div>
        <a-button class="button-start" ghost @click="toGeneration"
          >Start</a-button
        >
      </div>
      <div class="xkool-logo">
        <img :src="xkoolLogo" alt="xkool logo" width="12%" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Index",
  data() {
    return {
      // img path
      titleLogo: require("../assets/images/home_title_logo.png"),
      xkoolLogo: require("../assets/images/xkool_gray.png"),
    };
  },
  methods: {
    toGeneration() {
      this.$router.push({ path: "/generation" });
    },
  },
};
</script>

<style lang="less" scoped>
@main-color: #504c97dc;
.page-container {
  width: 100vw;
  height: 100vh;
  display: flex;
}
.left-part {
  width: 61vw;
  height: 100vh;
  // background-color: @main-color;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 30px 40px;
  background: url("../assets/images/home_big_img.png") center/100% 70%
    @main-color no-repeat;
}
.main-title {
  width: 100%;
}
.main-title-text-eng {
  color: white;
  font-size: 280%;
  font-weight: 500;
  font-weight: normal;
}
.main-title-text-chs {
  color: white;
  font-size: 180%;
  font-weight: 600;
}
.bottom-text {
  width: 100%;
  text-align: center;
  font-size: 90%;
  color: white;
  font-weight: lighter;
}
.right-part {
  width: 39vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding: 100px 40px 50px 40px;
}
.sub-title {
  width: 100%;
  flex-direction: column;
}
.sub-title-text-eng {
  color: @main-color;
  font-size: 24px;
  text-align: center;
  font-weight: 300;
}
.sub-title-text-chs {
  color: @main-color;
  text-align: center;
  font-size: 18px;
}
.drop-card {
  width: 380px;
  border-radius: 20px;
  background-color: @main-color;
  box-shadow: 0px 10px 41px 6px #a4a4a4;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding: 40px 0;
}
.drop-title-text {
  color: white;
  font-size: 18px;
  font-weight: 400;
  margin-top: 36px;
}
.drop-content-text {
  color: white;
  font-size: 14px;
  font-weight: 300;
  text-align: center;
  padding: 8px 0 18px;
}
.xkool-logo {
  width: 100%;
  text-align: center;
}

.button-start {
  padding: 0 50px;
  border-radius: 6px;
  font-size: 15px;
}
</style>
